import type { Request } from "express"

export const checkTrustProxyConfiguration = (req: Request) => {
    const trustProxy = req.app.get('trust proxy')
    const hasProxyHeaders = !!(
      req.headers['x-forwarded-for'] || 
      req.headers['x-forwarded-host'] || 
      req.headers['x-forwarded-proto']
    )

    if (hasProxyHeaders && (trustProxy === false || trustProxy === undefined)) {
      console.warn(`
⚠️  Tailscale Auth Middleware Warning ⚠️

Detected X-Forwarded-* headers but Express 'trust proxy' is not configured.
This may result in incorrect IP address detection and authentication failures.

To fix this, add one of the following to your Express app:

  // For most reverse proxy setups (recommended)
  app.set('trust proxy', ['loopback', 'linklocal', 'uniquelocal'])
  

See: https://expressjs.com/en/guide/behind-proxies.html
`)
return true
    }
    return false
  }